import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import { pathDict } from '@ui/config/paths';
import { useTranslations } from '@ui/i18n';
import type { GardenType } from '@ui/utils/garden';
import { replaceRouterWithoutRerender } from '@ui/utils/urlHistory';
import React, { useMemo } from 'react';

import { GardenLogo } from './GardenLogo';
import GardenViewGrowHelpers from './GardenViewGrowHelpers/GardenViewGrowHelpers';
import GardenViewGrowWater from './GardenViewGrowWater';
import { useGardenModalStore } from './useGardenModalStore';

export type GardenViewGrowProps = {
  gardenType: GardenType;
};

function GardenViewGrow({ gardenType }: GardenViewGrowProps) {
  const t = useTranslations();
  const activeView = useGardenModalStore((s) => s.activeView);
  const coinMode = useGardenModalStore((s) => s.coinMode);

  const tabModes = useMemo(() => {
    return [
      {
        mode: 'water',
        text: t('Water Garden'),
        routePath: pathDict[coinMode].garden[gardenType].GROW_WATER,
      },
      {
        mode: 'helper',
        text: t('Employ Helpers'),
        routePath: pathDict[coinMode].garden[gardenType].GROW_HELPERS,
      },
    ] as const;
  }, [coinMode, gardenType, t]);

  return (
    <>
      <InDesktop>
        <GardenLogo mb="28px" coinMode={coinMode} gardenType={gardenType} />
      </InDesktop>
      <Tabs
        defaultIndex={activeView === 'GROW_WATER' ? 0 : 1}
        onChange={(index) => {
          replaceRouterWithoutRerender(tabModes[index].routePath);
        }}
      >
        <TabList maxW={{ desktop: '500px' }} margin="auto">
          {tabModes.map((v) => {
            return <Tab key={v.mode}>{v.text}</Tab>;
          })}
        </TabList>
        <TabPanels>
          <TabPanel px="0" pt={6} py={0} pb={0}>
            <GardenViewGrowWater />
          </TabPanel>
          <TabPanel px={4} py={6}>
            <GardenViewGrowHelpers type={gardenType} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}

export default GardenViewGrow;
